module.exports = __webpack_public_path__ + "static/media/cancel_request.1536edc5.png";